<template>
  <div class="Contactus">
    <div class="cont wow bounceInUp">
      <ComTitlte titleEn="CONTACT US" titleZh="联系我们"></ComTitlte>
      <div class="main">
        <div class="m_left">
          <ul>
            <li>
              <i class="cicon cicon_phone"></i>
              <span>电话 ：020-83824230；020-83825892</span>
            </li>
            <li>
              <i class="cicon cicon_adress"></i>
              <span>地址：广州市天河区员村四横路1号大院2楼</span>
            </li>
            <li>
              <i class="cicon cicon_email"></i>
              <span>邮箱：GZ_CIA@126.COM</span>
            </li>
          </ul>
        </div>
        <div class="m_right">
          <img :src="qrcodeSrc" alt="二维码" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";
export default {
  name: "Contactus",
  data() {
    return {
      qrcodeSrc: require("../../assets/img/index/qrcode.png"),
      contactusInfo: {
        infoList: [],
        infoQscod: "",
      },
    };
  },
  mounted() {
    // 联系我们信息
    this.getEnterprisePage();
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
  methods: {
    async getEnterprisePage() {
      let _that = this;
      let res = await this.$request.getEnterprisePage();
      if (res.code == 200) {
        const { rows } = res;
        _that.contactusInfo.infoList = rows;
        _that.contactusInfo.infoQscod =
          _that.$store.state.baseUrl + rows[0].imageUrl1;
        // console.log("_that.getEnterprisePage", res.rows);
      }
    },
  },
  components: { ComTitlte },
};
</script>

<style lang="scss" scoped>
$themeColor: #406cdd;
.Contactus {
  width: 100%;
  min-width: 1180px;
  min-height: 376px;
  padding: 0 0 40px 0;
  overflow: hidden;
  .cont {
    width: 1180px;
    margin: 0 auto;
    .c_title {
      height: 44px;
      padding: 40px 0 0 0;
      position: relative;
      .t_es {
        font-size: 36px;
        font-weight: bold;
        color: #444444;
        opacity: 0.1;
      }
      .t_zh {
        font-size: 24px;
        line-height: 24px;
        font-weight: bold;
        color: #4466bb;
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
    .main {
      display: flex;
      box-sizing: border-box;
      width: 1180px;
      min-height: 300px;
      padding: 70px 0 0 30px;
      margin: 30px 0 0 0;
      background: url("../../assets/img/index/bg_cont_contactus.png") top center;
      background-size: cover;
      .m_left {
        width: 382px;
        ul {
          li {
            display: flex;
            align-items: center;
            padding: 0 0 32px;
            .cicon {
              display: block;
              width: 20px;
              height: 20px;
              &.cicon_phone {
                background: url(../../assets/img/index/cicon_phone.png)
                  no-repeat;
                background-size: cover;
              }
              &.cicon_adress {
                background: url(../../assets/img/index/cicon_adress.png)
                  no-repeat;
                background-size: cover;
              }
              &.cicon_email {
                background: url(../../assets/img/index/cicon_email.png)
                  no-repeat;
                background-size: cover;
              }
            }
            span {
              flex: 1;
              padding: 0 0 0 10px;
              line-height: 20px;
              display: block;
              font-size: 16px;
              color: #ffffff;
            }
          }
        }
      }
    }
  }
  .line {
    display: flex;
    .input_code {
      position: relative;
    }
    .chaImg {
      position: relative;
    }
  }
}
</style>
